import type { BuiltInMethodKey } from '@sifly/shared-types'
import { VenmoMark, ZelleMark } from './brandMarks'
import {
  CreditCard,
  Landmark,
  ArrowRightLeft,
  Mail,
  Wallet,
  type LucideIcon,
  type LucideProps,
} from 'lucide-react'

export type PaymentMethodKind = BuiltInMethodKey | 'other'

// Every registry method needs an entry: a new one fails to compile until it has
// an icon. Venmo and Zelle draw their official marks; the rest are Lucide.
const PAYMENT_METHOD_ICONS: Record<PaymentMethodKind, LucideIcon | 'venmo' | 'zelle'> = {
  card: CreditCard,
  ach: Landmark,
  wire: ArrowRightLeft,
  zelle: 'zelle',
  venmo: 'venmo',
  check: Mail,
  other: Wallet,
}

/**
 * Render a Lucide icon for a payment-method kind. Wraps the lookup so callers
 * don't materialize a component type during render (which the React Compiler
 * `static-components` rule flags as a stability hazard).
 */
export function PaymentMethodIcon({ kind, ...props }: LucideProps & { kind: PaymentMethodKind }) {
  const Icon = PAYMENT_METHOD_ICONS[kind] ?? Wallet
  if (Icon === 'venmo') return <VenmoMark size={props.size} className={props.className} />
  if (Icon === 'zelle') return <ZelleMark size={props.size} className={props.className} />
  return <Icon {...props} />
}
